import { Dropdown, IDropdownOption } from "@fluentui/react";
import { useMemo } from "react";
import { ISubscription, SubscriptionType } from "@/services/SubscriptionService";

type TUpgradeSubscriptionSelectorProps =  {
  subscriptions: SubscriptionType[];
  selectedId?: number;
  // Bloquea el cambio de tarifa mientras se está enviando el pago.
  disabled?: boolean;
  onChange: (subscription: SubscriptionType) => void;
}

const UpgradeSubscriptionSelector = ({
  subscriptions,
  selectedId,
  disabled,
  onChange,
}: TUpgradeSubscriptionSelectorProps) => {
  const options: IDropdownOption[] = useMemo(() => {
    return subscriptions.map((sub: ISubscription) => ({
      key: sub.id!,
      text: `${sub.name} ${
        sub.limit ? `(Límite: ${sub.limit})` : "(Sin límite)"
      }`,
      data: sub,
    }));
  }, [subscriptions]);

  const handleChange = (
    _event: React.FormEvent<HTMLDivElement>,
    option?: IDropdownOption
  ) => {
    if (!option) return;
    onChange(option.data);
  };

  return (
      <Dropdown
        label="Selecciona tu nueva suscripción"
        placeholder="Elige una opción"
        options={options}
        selectedKey={selectedId ?? null}
        disabled={disabled}
        onChange={handleChange}
      />
  );
};

export default UpgradeSubscriptionSelector;
